import { DarkTheme, LightTheme } from "constants/themes";
import { FONTSIZE_TYPES, THEME_TYPES } from "store/actions/types";

const themeReducer = (
  state = { theme: LightTheme, fontSize: "md" },
  action: { payload: any; type: string }
) => {
  switch (action.type) {
    case THEME_TYPES.SWITCH_THEME:
      return {
        ...state,
        theme: action.payload === "dark" ? DarkTheme : LightTheme,
      };
    case FONTSIZE_TYPES.CHANGE_FONTSIZE:
      return {
        ...state,
        fontSize: action.payload,
      };
    default:
      return state;
  }
};

export default themeReducer;
